import API from '@/api/api'

export default {
  // eslint-disable-next-line
  GET_INVITE ({}, inviteId) {
    return API.GET.invite(inviteId)
  },
  // eslint-disable-next-line
  SEND_INVITE ({}, data) {
    return API.POST.invite(data)
  },
  // eslint-disable-next-line
  SAVE_USER ({}, data) {
    return API.POST.judge(data)
  }
}
